import './App.css';
import Info from "./components/Info"
import About from "./components/About"
import Footer from "./components/Footer"

function App() {
  return (
    <div className="container">
      <Info />
      <About />
      <Footer />
    </div>
  );
}

export default App;
